import { request } from "./axiosInstance.js";

export const getProductionSummary = () => request("/production/summary");
export const getPlans = () => request("/production/plans");
export const savePlan = (data, id) =>
  request(`/production/plans${id ? `/${id}` : ""}`, {
    method: id ? "PUT" : "POST",
    body: JSON.stringify(data),
  });
export const getMachines = () => request("/production/machines");
export const saveMachine = (data, id) =>
  request(`/production/machines${id ? `/${id}` : ""}`, {
    method: id ? "PUT" : "POST",
    body: JSON.stringify(data),
  });
export const getEmployees = () => request("/production/employees");
export const saveEmployee = (data, id) =>
  request(`/production/employees${id ? `/${id}` : ""}`, {
    method: id ? "PUT" : "POST",
    body: JSON.stringify(data),
  });
export const getJobs = () => request("/production/jobs");
export const getCuttingMachinePlans = (params = {}) =>
  request(`/production/cutting-machine-plans?${new URLSearchParams(params)}`);
export const getCuttingMachineStatus = () =>
  request("/production/cutting-machine-status");
export const saveCuttingMachinePlan = (data) =>
  request("/production/cutting-machine-plans", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const cuttingMachineAction = (id, action, reason = "") =>
  request(`/production/cutting-machine-plans/${id}/action`, {
    method: "PATCH",
    body: JSON.stringify({ action, reason }),
  });
export const transferCuttingMachinePlan = (id, machineCode, reason = "") =>
  request(`/production/cutting-machine-plans/${id}/transfer`, {
    method: "PATCH",
    body: JSON.stringify({ machineCode, reason }),
  });
export const getProductionDc = (dcNo) =>
  request(`/production/dc/${encodeURIComponent(dcNo)}`);
export const startProductionJob = (data) =>
  request("/production/jobs/start", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const stopProductionJob = (id, data) =>
  request(`/production/jobs/${id}/stop`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
export const resumeProductionJob = (id) =>
  request(`/production/jobs/${id}/resume`, { method: "PATCH" });
export const getPendingIssues = () => request("/production/pending");
export const savePendingIssue = (data, id) =>
  request(`/production/pending${id ? `/${id}` : ""}`, {
    method: id ? "PUT" : "POST",
    body: JSON.stringify(data),
  });
export const changePendingStatus = (id, status) =>
  request(`/production/pending/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
export const deletePendingIssue = (id) =>
  request(`/production/pending/${id}`, { method: "DELETE" });
export const getSewingDeliveries = () => request("/production/sewing");
export const createSewingDelivery = (data) =>
  request("/production/sewing", { method: "POST", body: JSON.stringify(data) });
export const getSewingHolds = () => request("/production/sewing-holds");
export const saveSewingHold = (data) =>
  request("/production/sewing-holds", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const resolveSewingHold = (id, status = "Resolved") =>
  request(`/production/sewing-holds/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
export const getWarehouse = (type = "", dcNo = "") =>
  request(
    `/warehouse?${new URLSearchParams({ ...(type && { type }), ...(dcNo && { dcNo }) })}`,
  );
export const getCuttingDcs = () => request("/production/cutting-dcs");
export const getCuttingDc = (dcNo) =>
  request(`/production/cutting-dcs/${encodeURIComponent(dcNo)}`);
export const saveCuttingDc = (data) =>
  request("/production/cutting-dcs", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const getMeasurements = (params = {}) =>
  request(`/production/measurements?${new URLSearchParams(params)}`);
export const transferRework = (id, data) =>
  request(`/warehouse/rework/${id}`, {
    method: "POST",
    body: JSON.stringify(data),
  });
export const deliverWarehouseStock = (id, data) =>
  request(`/warehouse/deliver/${id}`, {
    method: "POST",
    body: JSON.stringify(data),
  });
